/* eslint-disable sciencepo-rules/require-story */
import * as testimonieDiapoStyles from '../../styles/internal-page/testimonie-diapo.module.scss';
import * as styleLink from '../../styles/communs/polylink.module.scss';
import PropTypes from 'prop-types';

import React from 'react';
import PolyLink from '../shared/PolyLink';
import IconContainer from '../shared/IconContainer';
import clsx from 'clsx';

const TestimonieContent = ({elem}) => {
  if (!elem) {
    return null;
  }
  return (
    <>
      {(elem.quote || elem.content) &&
        <p className={testimonieDiapoStyles.citation}>
          <span
            className={testimonieDiapoStyles.caractere}
            dangerouslySetInnerHTML={{
              __html: '&laquo '
            }}
          />
          <span
            className={testimonieDiapoStyles.detailText}
            dangerouslySetInnerHTML={{
              __html: elem.quote || elem.content.replace(/(<([^>]+)>)/ig, '')
            }}
          />
          <span
            className={testimonieDiapoStyles.caractere}
            dangerouslySetInnerHTML={{
              __html: ' &raquo'
            }}
          />
        </p>
      }
      {elem.first_name && elem.last_name &&
        <p className={testimonieDiapoStyles.title}>
          {elem.first_name + ' ' + elem.last_name}
        </p>
      }
      {elem.name &&
        <p className={testimonieDiapoStyles.title}>
          {elem.name}
        </p>
      }
      <p className={testimonieDiapoStyles.job}>
        {[elem.job, elem.jobDescription].filter(e => e).join(', ')}
      </p>
      {elem.link && elem.link_label &&
        <PolyLink
          ariaLabel={elem.link_label}
          className={testimonieDiapoStyles.containerLink}
          target={elem.link_new_window ? '_blank' : ''}
          url={elem.link}
        >
          <p className={clsx(testimonieDiapoStyles.linkLabel, styleLink.withoutIcon)}>
            {elem.link_label}
          </p>
          <IconContainer
            classname={testimonieDiapoStyles.more}
            color="RED"
            icon="ARROW_RIGHT_NORMAL"
            noHover
            size={20}
          />
        </PolyLink>
      }
    </>
  );
};

TestimonieContent.propTypes = {
  elem: PropTypes.shape({
    quote: PropTypes.string,
    link_new_window: PropTypes.bool,
    name: PropTypes.string,
    link: PropTypes.string,
    link_label: PropTypes.string,
    jobDescription: PropTypes.string,
    content: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    job: PropTypes.string
  }).isRequired,
};

export default TestimonieContent;
